import { MutationOptions } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useCanTriggerScan from "shared/Scan/access/useCanTriggerScan";
import { ScanRunState } from "types/generated";

import { SCAN_RUN_TRIGGER } from "./gql";

export type ScanForTrigger = {
  id: string;
  space: { id: string };
  latestRun?: { state: ScanRunState } | null;
};

type UseTriggerScanOptions = {
  scan: ScanForTrigger;
  refetchQueries?: MutationOptions["refetchQueries"];
};

const useTriggerScan = ({ scan, refetchQueries }: UseTriggerScanOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const canTrigger = useCanTriggerScan()(scan);

  const [triggerScanRun, { loading: isTriggering }] = useMutation(SCAN_RUN_TRIGGER, {
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const trigger = () => {
    triggerScanRun({ variables: { scan: scan.id } })
      .then(({ data }) => {
        if (data?.scanRunTrigger.id) {
          reportSuccess({ message: "Scan successfully triggered" });
        }
      })
      .catch(onError);
  };

  return {
    canTrigger,
    showTrigger: canTrigger.result || !!canTrigger.message,
    isTriggering,
    trigger,
    isTriggerDisabled: isTriggering || !canTrigger.result,
  };
};

export default useTriggerScan;
